export enum ArFeatureRenderingMode {
    UNDEFINED = 'UNDEFINED',
    FORM = 'FORM',
    PRINT_PREVIEW = 'PRINT',
}
